import React from 'react';
import { Users, BookOpen, Gift, Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-12 bg-surface border-y border-white/5" aria-label="Estadísticas y testimonios de clientes" data-id="element-356">
      <div className="container mx-auto px-4" data-id="element-357">
        {/* Stats Bar */}
        <FadeIn data-id="element-358">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-16" data-id="element-359">
            <div className="flex flex-col items-center text-center px-4" data-id="element-360">
              <Users className="w-8 h-8 text-cyan mb-3" aria-hidden="true" data-id="element-361" />
              <span className="text-2xl font-bold text-white font-heading" data-id="element-362">
                +800
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-363">
                Conductores
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-364">
              <BookOpen className="w-8 h-8 text-cyan mb-3" aria-hidden="true" data-id="element-365" />
              <span className="text-2xl font-bold text-white font-heading" data-id="element-366">
                6
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-367">
                Módulos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-368">
              <Gift className="w-8 h-8 text-cyan mb-3" aria-hidden="true" data-id="element-369" />
              <span className="text-2xl font-bold text-white font-heading" data-id="element-370">
                5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-371">
                Bonos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-372">
              <div className="flex gap-1 mb-3" role="img" aria-label="Calificación: 4.9 de 5 estrellas" data-id="element-373">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow text-yellow" aria-hidden="true" data-id="element-374" />)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-375">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-376">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-377">
          <FadeIn delay={0.1} data-id="element-378">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-379">
              <div className="flex gap-1 mb-4" role="img" aria-label="Calificación: 5 de 5 estrellas" data-id="element-380">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow text-yellow" aria-hidden="true" data-id="element-381" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-382">
                "Los scripts para el mecánico me ahorraron más de $80.000 en el
                primer mes."
              </p>
              <div className="flex items-center gap-3" data-id="element-383">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-cyan" data-id="element-384">
                  R
                </div>
                <div data-id="element-385">
                  <p className="font-bold text-white text-sm" data-id="element-386">Ricardo M.</p>
                  <p className="text-xs text-gray-400" data-id="element-387">Buenos Aires</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-388">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-389">
              <div className="flex gap-1 mb-4" role="img" aria-label="Calificación: 5 de 5 estrellas" data-id="element-390">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow text-yellow" aria-hidden="true" data-id="element-391" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-392">
                "El checklist pre-viaje me salvó de salir con una falla que no
                había notado."
              </p>
              <div className="flex items-center gap-3" data-id="element-393">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-cyan" data-id="element-394">
                  V
                </div>
                <div data-id="element-395">
                  <p className="font-bold text-white text-sm" data-id="element-396">Valeria T.</p>
                  <p className="text-xs text-gray-400" data-id="element-397">Córdoba</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-398">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-399">
              <div className="flex gap-1 mb-4" role="img" aria-label="Calificación: 5 de 5 estrellas" data-id="element-400">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow text-yellow" aria-hidden="true" data-id="element-401" />)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-402">
                "Nunca pensé que iba a entender el tablero tan fácil. Ahora no
                entro en pánico."
              </p>
              <div className="flex items-center gap-3" data-id="element-403">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-cyan" data-id="element-404">
                  M
                </div>
                <div data-id="element-405">
                  <p className="font-bold text-white text-sm" data-id="element-406">Marcelo D.</p>
                  <p className="text-xs text-gray-400" data-id="element-407">Rosario</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}